module.exports = __webpack_public_path__ + "static/img/fw.745763e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/fw.jpg
// module id = /yy3
// module chunks = 1